import { useState, useEffect } from "react";

const useSearchParams = () => {
  const [params, setParams] = useState(new URLSearchParams(window.location.search));

  useEffect(() => {
    const handlePopState = () => {
      setParams(new URLSearchParams(window.location.search));
    };
    
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const setQueryParam = (key, value) => {
    const newParams = new URLSearchParams(window.location.search);
    if (value === null) {
      newParams.delete(key);
    } else {
      newParams.set(key, value);
    }
    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.history.pushState(null, "", newUrl);
    setParams(newParams);
  };

  return [params, setQueryParam];
};

export default useSearchParams;
